export default {
  /**
   * Convert a serialized JWT to JS Object representations
   *
   * Note that this method does not (currently) provide any validation or error handling so the
   * caller should be careful to either provide valid input or handle exceptions raised
   *
   * @param {string} text  Serialized JWT to parse
   * @return {any} Object representation of JWT claims
   */
  parse(text) {
    return JSON.parse(atob(text.split('.')[1]));
  }
};
